module.exports = __webpack_public_path__ + "static/media/IDTB.f243e30e.svg";